import React from 'react';

class ScoreScaleBarBasicPercentage extends React.Component {
  render() {
    return (
        <span className={"score-scale " + this.props.classes}
          style={{ transform: "translateX(" + (this.props.prof * 2.5 - 5) + "px)" }}>
        </span>
    );
  }
}

export default ScoreScaleBarBasicPercentage;



// WEBPACK FOOTER //
// ./src/ScoreScaleBarBasicPercentage.js